import React from "react";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon
} from "react-share";

export default function SharePopup({ onClose }) {
  const shareUrl = window.location.href;
  const title = "Check out this article!";

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <h3 style={styles.heading}>Share this story</h3>

        <div style={styles.buttons}>
          <FacebookShareButton url={shareUrl} quote={title}>
            <FacebookIcon size={48} round />
          </FacebookShareButton>

          <WhatsappShareButton url={shareUrl} title={title}>
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>

          <TwitterShareButton url={shareUrl} title={title}>
            <TwitterIcon size={48} round />
          </TwitterShareButton>

          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon size={48} round />
          </LinkedinShareButton>
        </div>

        <button style={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

// Inline styles (you can convert to CSS)
const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  popup: {
    background: "#fff",
    padding: "20px 30px",
    borderRadius: "10px",
    width: "320px",
    textAlign: "center"
  },
  heading: {
    marginBottom: "15px"
  },
  buttons: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: "20px"
  },
  closeBtn: {
    padding: "8px 20px",
    borderRadius: "8px",
    border: "none",
    background: "#ff5722",
    color: "#fff",
    cursor: "pointer"
  }
};
